import styled, {css} from "styled-components";
import {Collapse as RSCollapse} from "reactstrap";

/**
 * This component is us taking Reactstrap collapse, and providing the
 * bootstrap styles our selves so we have no dependencies **/

export const Collapse = styled(RSCollapse)`
  && {
    transition: all .2s ease-in-out;
    transition: height .35s ease;
    
    ${({removeMarginFromChildren}) => removeMarginFromChildren !== false && css`
      > div {
        margin-top: 0;
        margin-bottom: 0;
      }
    `};
    
    .fade {
     transition: opacity .15s linear;
    
      &:not(.show) {
        opacity: 0;
      }
    }
    &.collapse:not(.show) {
      display: none;
    }
    
    &.collapsing {
      position: relative;
      height: 0;
      overflow: hidden;
    }
  }
`;


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/PureCollapse.js